import { render, staticRenderFns } from "./AvaliacaoGeral.vue?vue&type=template&id=0c54d99e&scoped=true"
import script from "./AvaliacaoGeral.vue?vue&type=script&lang=ts"
export * from "./AvaliacaoGeral.vue?vue&type=script&lang=ts"
import style0 from "./AvaliacaoGeral.vue?vue&type=style&index=0&id=0c54d99e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c54d99e",
  null
  
)

export default component.exports